export enum Tests {
  PERSONALITY = 'PERSONALITY',
  MOTIVATION = 'MOTIVATION',
  NUMERICAL = 'NUMERICAL',
  INDUCTIVE = 'INDUCTIVE',
  VERBAL = 'VERBAL',
  COGNITIVE_COMBINED = 'COGNITIVE_COMBINED',
}

/**
 * Retired GraphQL enum kept as local display vocabulary: keys the per-kind
 * test intro copy/config for the assessment action flows.
 */
export enum TestKind {
  Personality = 'PERSONALITY',
  CognitiveInductive = 'COGNITIVE_INDUCTIVE',
  CognitiveNumerical = 'COGNITIVE_NUMERICAL',
  CognitiveVerbal = 'COGNITIVE_VERBAL',
  EnglishProficiency = 'ENGLISH_PROFICIENCY',
}

export enum TestStatus {
  NOT_STARTED = 'NOT_STARTED',
  IN_PROGRESS = 'IN_PROGRESS',
  EXPIRED = 'EXPIRED',
  COMPLETED = 'COMPLETED',
}

export enum PersonalityTestsAnswers {
  STRONGLY_DISAGREE,
  DISAGREE,
  SLIGHTELY_DISAGREE,
  NEUTRAL,
  SLIGHTELY_AGREE,
  AGREE,
  STRONGLY_AGREE,
}

export enum VerbalTestAnswers {
  DEFINITELY_FALSE,
  PROBABLY_FALSE,
  NEUTRAL,
  PROBABLY_TRUE,
  DEFINITELY_TRUE,
}
